import type { IconProps } from './types';

export const ChartIcon: React.FC<IconProps> = ({
  className,
  width = '16px',
  height = '16px',
  color = 'currentColor',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icons/chart-line">
      <path
        id="vector"
        d="M2.5 2.5V14.1667C2.5 16.0076 3.99238 17.5 5.83333 17.5H17.5M17.5 6.66667L14.3703 10.6906C13.9811 11.191 13.2411 11.191 12.8519 10.6906L10.38 7.5124C10.0464 7.08345 9.39806 7.08345 9.06443 7.5124L5.83333 11.6667"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
